export const getKey = (curPath, object) => {
  return curPath ? `${curPath}/${object.name}` : object.name;
};
